import { SyslogSeverity } from './SyslogSeverity'
import type { VtexLogLevel } from '../VtexLog'

/**
 * Reference: The place which we define our receiver to accept syslog
 * Link: https://github.com/vtex/observability/blob/opentelemetry-extensions/v0.12.7/opentelemetry-extensions/builder.yaml#L17
 *
 * Reference: The receiver code which map SyslogSeverity to OpenTelemetry severity
 * Link: https://github.com/open-telemetry/opentelemetry-collector-contrib/blob/v0.54.0/pkg/stanza/operator/parser/syslog/syslog.go#L224-L233
 */
const LOG_LEVEL_TO_SYSLOG_SEVERITY: Record<VtexLogLevel, SyslogSeverity> = {
  debug: SyslogSeverity.Debug,
  info: SyslogSeverity.Info,
  warning: SyslogSeverity.Warning,
  error: SyslogSeverity.Error,
  fatal: SyslogSeverity.Emergency,
}

export function getSyslogSeverityFromPinoLevel(level: VtexLogLevel) {
  return LOG_LEVEL_TO_SYSLOG_SEVERITY[level]
}
